import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './cumulative-winners/items';

const cumulativeWinners = combineReducers({
  items,
  isLoading: loadingStatusAccordingToReducer('cumulativeWinnersStatusLoadingStatus'),
});

export default cumulativeWinners;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/cumulative-winners.reducer.js